import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=8e7fd12e&scoped=true&"
import script from "./AppDownload.vue?vue&type=script&lang=ts&"
export * from "./AppDownload.vue?vue&type=script&lang=ts&"
import style0 from "./AppDownload.vue?vue&type=style&index=0&id=8e7fd12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7fd12e",
  null
  
)

export default component.exports